export default __webpack_public_path__ + "static/media/jive-web-app-landing-animation.e65668ec.gif";